module.exports = __webpack_public_path__ + "static/media/background-svg-1.dc767389.svg";